import React, { useState } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { useNavigate } from "react-router-dom";
import { useContactUsMutation } from "../../api/user/userAccount";
import { toast } from "react-toastify";
import { t } from "i18next";

const AssistenzaPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Subject: "",
    Description: "",
  });

  const [contactUs, { isLoading: isContactUsLoading }] = useContactUsMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleContatta = async () => {
    contactUs(formData)
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Result === 1) {
          toast.success(t("AssistanceMessageSended"));
          setFormData({ Subject: "", Description: "" });
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  return (
    <div className="w-full flex justify-center">
      <div style={{ width: "700px", marginTop: "2rem" }}>
        <h2 className="text-center">{t("ContactUs")}</h2>
        <p>{t("ContactSection")}</p>

        <FormControl size="small" sx={{ width: "700px", marginTop: "2rem" }}>
          <InputLabel id="motivoContatto-label" className="text-center">
            {t("ContactReason")}
          </InputLabel>
          <Select
            sx={{ maxWidth: "700px" }}
            label="motivoContatto-label"
            name="Subject"
            value={formData.Subject}
            onChange={handleChange}
            required
          >
            <MenuItem value="assistenza">Assistenza</MenuItem>
            <MenuItem value="informazioni">Informazioni</MenuItem>
            <MenuItem value="eliminazione">Richiesta di cancellazione</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ width: "700px", marginTop: "3rem" }}>
          <CoreTextArea
            name="Description"
            type="text"
            minRows={4}
            placeholder={
              formData.Subject === "eliminazione"
                ? t("InsertAReason")
                : t("WriteAMessage")
            }
            value={formData.Description}
            onChange={handleChange}
            sx={{ width: "100%", resize: "none", marginTop: "0.5rem" }}
            required
          />
        </FormControl>
        <div className="flex justify-evenly mt-12">
          <CoreButton
            sx={{ width: "150px", textAlign: "center" }}
            className={"btn-round-outline"}
            variant="outline"
            testo={t("Cancel")}
            onClick={handleCancel}
            disabled={isContactUsLoading}
          />
          <CoreButton
            sx={{ width: "150px", textAlign: "center" }}
            className={"btn-round"}
            variant="contained"
            testo={t("Send")}
            onClick={handleContatta}
            disabled={
              isContactUsLoading || !formData.Description || !formData.Subject
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AssistenzaPage;
